export const formatInputDate = (value) => {
    const input = value.replace(/\D/g, "").substring(0, 8);
    const month = input.substring(0, 2);
    const day = input.substring(2, 4);
    const year = input.substring(4, 8);

    if (input.length > 4) {
        return `${month}/${day}/${year}`;
    } else if (input.length > 2) {
        return `${month}/${day}`;
    } else if (input.length > 0) {
        return `${month}`;
    }

    return input;
};
